<script>
export default {
  inject: ['handleClass'],
  mounted() {
    this.$el.classList.add(this.handleClass);
  },
  render() {
    return this.$slots.default[0];
  }
};
</script>